import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import CollapsibleWrapper, { Panel } from '../../../components/wrappers/CollapsibleWrapper';
import FormFields from '../../../themes/admin/Fields/FormFields';
import useSystemSwitchData from '../../../utilities/useSystemSwitchData';

const colSpan = { lg: 8, xs: 24 };

export type MakeDetailsFormProps = {
    updated?: string;
    offset?: string;
    disabled?: boolean;
};

const MakeDetailsForm = ({ updated, offset, disabled = false }: MakeDetailsFormProps) => {
    const { t } = useTranslation('makeDetails');

    const { yesNoSwitch } = useSystemSwitchData();

    return (
        <CollapsibleWrapper defaultActiveKey={t('makeDetails:cardTitles.makeDetails')}>
            <Panel key={t('makeDetails:cardTitles.makeDetails')} header={t('makeDetails:cardTitles.makeDetails')}>
                <Row gutter={14}>
                    <Col {...colSpan}>
                        <FormFields.InputField
                            {...t('makeDetails:fields.identifier', {
                                returnObjects: true,
                            })}
                            disabled={disabled}
                            name="identifier"
                            required
                        />
                    </Col>
                    <Col {...colSpan}>
                        <FormFields.TranslatedInputField
                            {...t('makeDetails:fields.name', {
                                returnObjects: true,
                            })}
                            disabled={disabled}
                            name="name"
                            required
                        />
                    </Col>
                    <Col {...colSpan}>
                        <FormFields.InputNumberField
                            {...t('makeDetails:fields.order', {
                                returnObjects: true,
                            })}
                            disabled={disabled}
                            min={1}
                            name="order"
                            required
                        />
                    </Col>
                    <Col {...colSpan}>
                        <FormFields.SwitchField
                            {...t('makeDetails:fields.isActive', {
                                returnObjects: true,
                            })}
                            disabled={disabled}
                            name="isActive"
                            {...yesNoSwitch}
                            required
                        />
                    </Col>
                    <Col {...colSpan}>
                        <FormFields.DisplayFieldWithUTCOffset
                            {...t('common:fields.updated', { returnObjects: true, offset })}
                            value={updated}
                        />
                    </Col>
                </Row>
            </Panel>
        </CollapsibleWrapper>
    );
};

export default MakeDetailsForm;
